import { render, staticRenderFns } from "./DesignModal.vue?vue&type=template&id=921496ce&scoped=true"
import script from "./DesignModal.vue?vue&type=script&lang=js"
export * from "./DesignModal.vue?vue&type=script&lang=js"
import style0 from "./DesignModal.vue?vue&type=style&index=0&id=921496ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921496ce",
  null
  
)

export default component.exports